import notify from 'devextreme/ui/notify';
import React, { useEffect, useRef, useState } from 'react';
import { DataForEPuapType } from '../../../Types/DataForEPuapType';
import api from '../../../_helpers/Request/api';
import { confirm } from 'devextreme/ui/dialog';
import { EPuapType } from '../../../Types/EPuapType';
import { dataSourceComboInt } from '../../../_helpers/DataSource/dataSourceComboInt';
import Button from 'devextreme-react/button';
import LoadPanel from 'devextreme-react/load-panel';
import FileUploader from 'devextreme-react/file-uploader';
import TextBox from 'devextreme-react/text-box';
import { useHistory } from 'react-router-dom';

const EPUAPSendManyXML = () => {
    const [ePuapData, setEPuapData] = useState<EPuapType>();
    const formRef = useRef<HTMLFormElement>(null);
    const [loadPanelVisible, setLoadPanelVisible] = useState<boolean>(false);
    const fileInputRef = React.createRef<any>();
    const [files, setFiles] = useState([]);
    const [addressResponse, setAddressResponse] = useState<string>('');

    const history = useHistory();

    const onSubmit = () => {
        sendToEpuap();
    };

    const fileHandleChange = (e: any) => {
        setFiles(e);
    };

    //console.log(fileInputRef, 'fileInputRef');

    const DataForEPuap: any = async () => {
        if (!addressResponse || addressResponse === '') {
            notify('Uzupełnij Adres skrzynki ePUAP do odpowiedzi', 'error', 5000);
            return;
        }

        var formData = new FormData();
        files.forEach((element) => {
            formData.append('files', element);
        });
        formData.append('addressResponse', addressResponse);

        // var dataFor = {
        //     files,
        //     addressResponse,
        // }

        //console.log(formData, 'formData');

        /*
 var formData = new FormData();
        files.forEach((element) => {
            formData.append('dto', element);
        });
        console.log(formData, 'formData');
        */

        try {
            const { data, status } = await api.post('/epuap/SendXMLsToePuap', formData, {
                responseType: 'blob'
            });
            //console.log(data, 'data');
            if (status === 200) {
                var url = window.URL || window.webkitURL;
                const link = url.createObjectURL(data);
                var a = document.createElement('a');
                a.setAttribute('download', 'upp.zip');
                a.setAttribute('href', link);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                //setLoadPanelVisible(false);
                notify('Pliki zostały poprawnie przesłane, potwierdzenia UPP zostały pobrane ', 'success', 10000);
            } else {
                notify('Wysyłanie plików nie powiodło się ', 'error', 10000);
            }

            // return data;
        } catch (err: any) {
            //console.log(err?.response, 'err?.response,');
            //console.log(err?.response?.data, 'err?.response?.data ');
            let errorString = JSON.parse(await err.response.data.text());
            //console.log(errorString, 'errorString');
            notify(errorString ?? 'Wysyłanie plików nie powiodło się', 'error', 5000);
            //setTimeout(() => DataForEPuap(), 3000);
        }
    };

    const sendToEpuap = async () => {
        if (!files || files.length === 0) {
            notify('Proszę wybrać pliki do wysłania', 'error', 5000);
            return;
        }

        try {
            setLoadPanelVisible(true);
            const ePuapData = await DataForEPuap();
            // const confirmSendEpuap = await confirm('Uwaga za chwile zostaniesz przekierowany na platformę profilu zaufanego w celu podpisania dokumentu. Czy potwierdzasz ten krok?', 'Uwaga');
            // if (confirmSendEpuap && ePuapData) {
            //     formRef.current?.submit();
            // }
            // console.log(ePuapData, 'ePuapData');
            setLoadPanelVisible(false);
        } catch {
            setLoadPanelVisible(false);
            notify(' ePUAP nie odpowiada.', 'error', 5000);
        }
    };

    return (
        <>
            <br /> <br />
            <div className="mainHeaderTitle">Wysyłanie zbiorcze deklaracji XML </div>
            <br /> <br />
            <LoadPanel shadingColor="rgba(0,0,0,0.4)" visible={loadPanelVisible} showIndicator={true} shading={true} showPane={true} closeOnOutsideClick={false} />
            <div style={{ alignItems: 'center', textAlign: 'center' }}>
                <></>
                <form ref={formRef} id="form1" onSubmit={() => onSubmit()} action={ePuapData?.url} method="post" target="_blank">
                    <div className="col-12 col-xl-6">
                        <label className="dx-field-label" id="street" htmlFor="street">
                            Adres skrzynki ePUAP do odpowiedzi
                        </label>
                        <div className="dx-field-value" style={{ width: '300px' }}>
                            <TextBox
                                className="normalText"
                                id="ePuapAddress"
                                name="ePuapAddress"
                                inputAttr={{ id: 'ePuapAddress' }}
                                aria-required="true"
                                aria-describedby="ePuapAddress"
                                maxLength={100}
                                value={addressResponse}
                                onValueChange={(e) => {
                                    setAddressResponse(e);
                                    //console.log(e, 'asdasd');
                                }}
                                stylingMode="underlined"
                                placeholder=""
                            />
                            
                        </div>
                        {/*    </> */}
                    </div>
                    {/* <div className="col-12 col-xl-6" > */}
                    <FileUploader
                        className="attachmentFeedback"
                        ref={fileInputRef}
                        selectButtonText="Dołącz załączniki"
                        labelText=""
                        accept=".xml"
                        uploadMode="useButtons"
                        onValueChanged={(e) => {
                            fileHandleChange(e.value);
                        }}
                        value={files != null ? files : []}
                        multiple
                    />
                    {/* </div> 
                    </div>*/}
                    {/* <div style={{ width: '400px',textAlign:'center', display: 'block', marginLeft: 'auto', marginRight: 'auto', verticalAlign: 'center' }}>
                        
                    </div> */}
                    <div className="hidd">
                        <input type="hidden" name="AdresSkrzynki" value={ePuapData?.boxAddress} />
                    </div>
                    <div>
                        <input type="hidden" name="XML" value={ePuapData?.declarationXml} />
                    </div>
                    <div className="hidd"></div>
                </form>

                <input
                    className="btn-primary"
                    type="submit"
                    title="Naciśnięcie przycisku spowoduje przekierowanie na tronę epuap.gov.pl"
                    onClick={() => sendToEpuap()}
                    value="Wyślij przez ePUAP"
                ></input>
            </div>
            <div style={{ height: '100px' }}></div>
            <hr />
            <div className="col-12 buttonSection">
                <button
                    title="Naciśnięcie przycisku spowoduje powrót na poprzednią stronę"
                    className="btnPrev"
                    onClick={() => {
                        history.push({
                            pathname: '/',
                            state: { new: false, fromLocalStorage: true }
                        });
                    }}
                >
                    Powrót
                </button>
            </div>
        </>
    );
};

export default EPUAPSendManyXML;
